// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"644a1b86","597":"13f11efa","837":"d0910428"}[chunkId] + ".chunk.css";
};